import { RegularStorage, StorageKeys } from 'services/mmkv';

export default function setFlagReturnToLauncher(appName?: string) {
    RegularStorage.setItem(StorageKeys.DEEPLINK_RETURN_TO_LAUNCHER, '1');

    if (appName) {
        RegularStorage.setItem(
            StorageKeys.DEEPLINK_THIRD_PART_APP_NAME,
            appName,
        );
    }
}
